import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isAuthenticated, getCurrentUser } from '../../utils/auth';

const ZPanelProtectedRoute = ({ children }) => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [authorized, setAuthorized] = useState(false);

    useEffect(() => {
        checkAuth();
    }, []);

    const checkAuth = async () => {
        if (!isAuthenticated()) {
            navigate('/zpanel/login');
            return;
        }

        try {
            const user = await getCurrentUser();
            if (user?.role === 'super_admin') {
                setAuthorized(true);
            } else {
                navigate('/zpanel/login');
            }
        } catch {
            navigate('/zpanel/login');
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-slate-900">
                <div className="animate-spin rounded-full h-12 w-12 border-2 border-amber-500 border-t-transparent"></div>
            </div>
        );
    }

    if (!authorized) return null;

    return children;
};

export default ZPanelProtectedRoute;
